import React from 'react'
import { connect } from 'react-redux'

import getLookupData from '../../api/profile/getLookupData'

class RootContainer extends React.Component<any, any> {
  componentWillMount() {
    this.props.onLoadData()
  }

  render() {
    return this.props.children
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    provinces: state.lookupData
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onLoadData: () => {
      dispatch(getLookupData(['COUNTRY']))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(RootContainer)
